import { styled } from "styled-components";

const Container = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1.5rem;
  gap: 0.8rem;

  & > svg {
    width: 1.5rem;
    height: auto;
  }
`;

const Title = styled.div`
  font-family: ${({ theme }) => theme.fonts.grotesk};
  font-size: 1.5rem;
  font-weight: 900;
  line-height: 29.76px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
`;

const Description = styled.div`
  font-family: Inter;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 19.6px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6875rem;
`;

const Footer = styled.div`
  display: flex;
  gap: 0.75rem;
  width: 100%;
  button {
    width: 100%;
    svg {
      path {
        fill: ${({ theme }) => theme.colors.white};
      }
    }
  }
`;

export default {
  Container,
  Header,
  Body,
  Symbol,
  Footer,
  Title,
  Description,
};
